<template>
  <div class="header" style="max-width: 100%">
    <div class="header-img" style="max-width: 100%">
      <a href="https://ped.cemaden.gov.br" target="_self" style="max-width: 100%">
        <img
          src="@/assets/banner_ped_v0_red.png"
          alt="PED - Plataforma de Entrega de Dados"
          style="max-width: 100%"
        />
      </a>
    </div>
  </div>

  <nav id="vue">
    <router-link
      v-if="loginStore.logado"
      to="/home"
      class="menu-item nav-item nav-link"
      id="home"
    >
      Home
    </router-link>

    <Dados v-if="loginStore.logado" title="Obtenção de Dados" />

    <router-link
      v-if="loginStore.logado"
      to="/AgendarReq"
      class="menu-item nav-item nav-link"
      id="agendarReq"
    >
      Status de Agendamento de Dados Históricos
    </router-link>

    <router-link
      v-if="loginStore.usuarioAdm"
      to="/CadastrarUsuarioAdm"
      class="menu-item nav-item nav-link"
      id="cadUsuarioAdm"
    >
      Cadastro de Usuário ADM
    </router-link>

    <router-link
      v-if="loginStore.logado"
      to="/ListarSensores"
      class="menu-item nav-item nav-link"
      id="listarSensores"
    >
      Lista de Sensores
    </router-link>

    <router-link
      v-if="loginStore.usuarioAdm"
      to="/AtualizarPerfilUsuario"
      class="menu-item nav-item nav-link"
      id="atualizarPerfilUsuario"
    >
      Atualiza Perfil de Usuário
    </router-link>

    <a
      v-if="loginStore.logado"
      class="menu-item nav-item nav-link"
      id="catalogo"
      href="http://sws.cemaden.gov.br"
      target="_blank"
      rel="noreferrer"
    >
      Catálogo de Serviços
    </a>

    <!-- Notificação (sininho) -->
    <!-- REGRA: só aparece se existir ao menos 1 agendamento com dtCreate nos últimos 7 dias -->
    <div
      class="menu-item menu-item--icon"
      v-if="loginStore.logado && badgeCount > 0"
      id="notificacao"
    >
      <button
        type="button"
        class="notif-btn"
        @click.prevent="toggleModal"
        aria-label="Agendamentos concluídos (últimos 7 dias)"
        title="Agendamentos concluídos (últimos 7 dias)"
      >
        <img src="@/assets/alarm_bell_red2.png" alt="Notificações" />
        <span v-if="badgeCount > 0" class="notif-badge">{{ badgeText }}</span>
      </button>
    </div>

    <Suporte v-if="loginStore.logado" title="Suporte" />
    <Acesso v-if="loginStore.logado" title="Acesso" />
  </nav>

  <!-- Modal moderno (teleport para o body) -->
  <teleport to="body">
    <div v-if="active" class="ped-modal" @click.self="closeModal">
      <div class="ped-modal__dialog" role="dialog" aria-modal="true">
        <header class="ped-modal__header">
          <div class="ped-modal__titlewrap">
            <div class="ped-modal__icon" aria-hidden="true">🔔</div>
            <div>
              <h5 class="ped-modal__title">Agendamentos concluídos</h5>
              <p class="ped-modal__subtitle">
                Exibindo apenas agendamentos criados nos últimos 7 dias.
              </p>
            </div>
          </div>

          <button
            type="button"
            class="ped-modal__close"
            @click="closeModal"
            aria-label="Fechar"
            title="Fechar"
          >
            ✕
          </button>
        </header>

        <section class="ped-modal__body">
          <div v-if="exibeTabelaAgendamento" class="ped-table-wrap">
            <table
              class="table table-hover table-responsive-lg ped-dt"
              style="width: 100%"
              id="tb_agendamentos_concluidos"
            ></table>
          </div>

          <div v-else class="ped-empty">
            <div class="ped-empty__title">Nada por aqui ainda</div>
            <div class="ped-empty__text">
              Não há agendamentos concluídos (últimos 7 dias) para exibir no momento.
            </div>
          </div>
        </section>

        <footer class="ped-modal__footer">
          <button type="button" class="btn btn-sm btn-secondary" @click="closeModal">
            Fechar
          </button>
        </footer>
      </div>
    </div>
  </teleport>
</template>

<script>
import Dados from "../components/Dados";
import Suporte from "../components/Suporte";
import Acesso from "../components/Acesso";
import { ref, computed, onMounted, onBeforeUnmount, nextTick } from "vue";
import $ from "jquery";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import { useLoginStore } from "../stores/LoginStore.js";
import { useRouter } from "vue-router";

export default {
  name: "navbar",
  components: { Dados, Suporte, Acesso },
  setup() {
    const exibeTabelaAgendamento = ref(false);
    const active = ref(false);

    const router = useRouter();
    const loginStore = useLoginStore();

    const DAYS_WINDOW = 7;

    function parseDateFlexible(value) {
      if (value === null || value === undefined || value === "") return null;

      if (value instanceof Date && !isNaN(value.getTime())) return value;

      if (typeof value === "number") {
        const d = new Date(value);
        return isNaN(d.getTime()) ? null : d;
      }

      const s = String(value).trim();
      if (!s) return null;

      // 1) tenta parse direto (ISO, RFC, etc.)
      let d = new Date(s);
      if (!isNaN(d.getTime())) return d;

      // 2) formato comum: "YYYY-MM-DD HH:mm:ss" -> "YYYY-MM-DDTHH:mm:ss"
      if (/^\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}(:\d{2})?/.test(s)) {
        d = new Date(s.replace(" ", "T"));
        if (!isNaN(d.getTime())) return d;
      }

      // 3) formato BR: "DD/MM/YYYY" ou "DD/MM/YYYY HH:mm:ss"
      const m = s.match(
        /^(\d{2})\/(\d{2})\/(\d{4})(?:\s+(\d{2}):(\d{2})(?::(\d{2}))?)?$/
      );
      if (m) {
        const dd = Number(m[1]);
        const mm = Number(m[2]) - 1;
        const yyyy = Number(m[3]);
        const HH = Number(m[4] || 0);
        const MI = Number(m[5] || 0);
        const SS = Number(m[6] || 0);

        const dt = new Date(yyyy, mm, dd, HH, MI, SS);
        return isNaN(dt.getTime()) ? null : dt;
      }

      return null;
    }

    function isWithinLastDays(dateValue, days) {
      const dt = parseDateFlexible(dateValue);
      if (!dt) return false;

      const cutoff = new Date(Date.now() - days * 24 * 60 * 60 * 1000);
      return dt >= cutoff;
    }

    const recentRequisicoesConcluidas = computed(() => {
      const arr = loginStore.requisicoesConcluidas || [];
      if (!Array.isArray(arr)) return [];

      // REGRA: só últimos 7 dias por dtCreate
      return arr.filter((r) => isWithinLastDays(r?.dtCreate, DAYS_WINDOW));
    });

    const badgeCount = computed(() => recentRequisicoesConcluidas.value.length);

    const badgeText = computed(() => {
      const n = badgeCount.value;
      if (n > 99) return "99+";
      return String(n);
    });

    function escapeHtml(value) {
      return String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }

    function truncateText(value, maxLen = 70) {
      const s = String(value);
      if (s.length <= maxLen) return s;
      return s.slice(0, maxLen - 1) + "…";
    }

    function setBodyLock(lock) {
      const body = document.querySelector("body");
      if (!body) return;
      lock ? body.classList.add("modal-open") : body.classList.remove("modal-open");
    }

    function destroyDataTable() {
      try {
        if ($.fn.DataTable && $.fn.DataTable.isDataTable("#tb_agendamentos_concluidos")) {
          const dt = $("#tb_agendamentos_concluidos").DataTable();
          dt.clear();
          dt.destroy();

          // limpa estrutura antiga
          $("#tb_agendamentos_concluidos thead").remove();
          $("#tb_agendamentos_concluidos tbody").remove();
          $("#tb_agendamentos_concluidos").empty();
        }
      } catch (e) {
        console.warn("Falha ao destruir DataTable:", e);
      }
    }

    function initDataTable() {
      // REGRA: usa somente dados filtrados (últimos 7 dias)
      const data = recentRequisicoesConcluidas.value;

      exibeTabelaAgendamento.value = Array.isArray(data) && data.length > 0;
      if (!exibeTabelaAgendamento.value) return;

      destroyDataTable();

      if (!$.fn.DataTable) {
        console.warn("DataTables não está disponível (plugin não carregado).");
        return;
      }

      $("#tb_agendamentos_concluidos").DataTable({
        data,
        destroy: true,
        paging: true,
        searching: true,
        pageLength: 10,
        lengthMenu: [10, 25, 50, 100],
        pagingType: "simple_numbers",
        order: [[2, "desc"]], // dtLastUpdate desc
        scrollY: "55vh",
        scrollX: true,
        scrollCollapse: true,
        autoWidth: false,
        language: {
          emptyTable: "Não há agendamentos concluídos (últimos 7 dias).",
          search: "Buscar:",
          lengthMenu: "Mostrar _MENU_",
          info: "Exibindo _START_ a _END_ de _TOTAL_",
          infoEmpty: "Exibindo 0 a 0 de 0",
          paginate: { previous: "‹", next: "›" },
        },
        columnDefs: [
          {
            defaultContent: "-",
            targets: "_all",
            className: "dt-body-left",
          },
        ],
        columns: [
          { data: "id", title: "#Req" },
          { data: "dtCreate", title: "Criação" },
          { data: "dtLastUpdate", title: "Atualização" },
          {
            data: "link",
            title: "Link para download",
            render: function (data, type) {
              if (type !== "display") return data;
              if (!data) return "-";

              const full = escapeHtml(data);
              const short = escapeHtml(truncateText(data, 70));

              return `<a class="ped-link" href="${full}" download title="${full}">${short}</a>`;
            },
          },
          { data: "parameters", title: "Parâmetros" },
          { data: "status.description", title: "Status" },
        ],
      });
    }

    async function openModal() {
      // segurança: se por algum motivo não houver itens recentes, não abre
      if (badgeCount.value <= 0) return;

      active.value = true;
      setBodyLock(true);
      await nextTick();
      initDataTable();
    }

    function closeModal() {
      active.value = false;
      setBodyLock(false);
      destroyDataTable();
    }

    function toggleModal() {
      active.value ? closeModal() : openModal();
    }

    function onKeyDown(e) {
      if (!active.value) return;
      if (e.key === "Escape") closeModal();
    }

    onMounted(() => {
      if (!loginStore.token) {
        router.push({ path: "/efetuarLogin" });
      }
      window.addEventListener("keydown", onKeyDown);
    });

    onBeforeUnmount(() => {
      window.removeEventListener("keydown", onKeyDown);
      setBodyLock(false);
      destroyDataTable();
    });

    return {
      loginStore,
      router,
      exibeTabelaAgendamento,
      active,
      toggleModal,
      closeModal,
      badgeCount,
      badgeText,
    };
  },
};
</script>

<style>
nav {
  width: 100vw;
  background-color: #3276b1 !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

nav .menu-item {
  color: #fff;
  padding: 25px 40px;
  position: relative;
  text-align: center;
  border-bottom: 5px solid transparent;
  display: flex;
  transition: 0.4s;
  cursor: pointer;
}

nav .menu-item.active,
nav .menu-item:hover {
  background-color: #093f6e;
  border-bottom-color: #3276b1;
}

nav .menu-item a {
  color: inherit;
  text-decoration: none;
  display: block;
  width: 100%;
  height: 100%;
}

header {
  width: 100vw;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: rgb(70, 163, 192);
  padding: 20px 20px;
}

header .header-img {
  width: 100vw;
}

.menu-item--icon {
  align-items: center;
  justify-content: center;
}

/* Botão do sininho */
.notif-btn {
  position: relative;
  border: none;
  background: transparent;
  padding: 0;
  margin: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.notif-btn img {
  display: block;
}

.notif-badge {
  position: absolute;
  top: -8px;
  right: -10px;
  background: #ff3b30;
  color: #fff;
  border-radius: 999px;
  font-size: 12px;
  line-height: 1;
  padding: 5px 7px;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.25);
}

/* Modal moderno */
.ped-modal {
  position: fixed;
  inset: 0;
  background: rgba(10, 20, 35, 0.55);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 22px;
  z-index: 9999;
}

.ped-modal__dialog {
  width: min(1100px, 96vw);
  max-height: 88vh;
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.35);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.ped-modal__header {
  position: sticky;
  top: 0;
  z-index: 2;
  padding: 16px 18px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  background: linear-gradient(180deg, #f7fbff, #ffffff);
  border-bottom: 1px solid rgba(15, 40, 70, 0.1);
}

.ped-modal__titlewrap {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.ped-modal__icon {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(50, 118, 177, 0.12);
}

.ped-modal__title {
  margin: 0;
  font-weight: 700;
  color: #0f2d4a;
}

.ped-modal__subtitle {
  margin: 4px 0 0;
  color: #4d657b;
  font-size: 13px;
}

.ped-modal__close {
  border: none;
  background: rgba(15, 40, 70, 0.06);
  color: #0f2d4a;
  width: 36px;
  height: 36px;
  border-radius: 12px;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  transition: 0.2s;
}

.ped-modal__close:hover {
  background: rgba(15, 40, 70, 0.12);
}

.ped-modal__body {
  padding: 14px 16px 6px;
  overflow: auto;
}

.ped-modal__footer {
  padding: 12px 16px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  border-top: 1px solid rgba(15, 40, 70, 0.08);
  background: #ffffff;
}

/* Empty state */
.ped-empty {
  padding: 26px 8px;
  text-align: center;
}

.ped-empty__title {
  font-weight: 700;
  color: #0f2d4a;
  margin-bottom: 6px;
}

.ped-empty__text {
  color: #4d657b;
  font-size: 14px;
}

/* Container da tabela */
.ped-table-wrap {
  border: 1px solid rgba(15, 40, 70, 0.08);
  border-radius: 14px;
  overflow: hidden;
  background: #fff;
}

/* Link do download: truncado + tooltip */
.ped-link {
  display: inline-block;
  max-width: 520px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
  color: #0b63b6;
  text-decoration: none;
}
.ped-link:hover {
  text-decoration: underline;
}

/* Ajustes gerais do DataTables */
table.dataTable thead th {
  background: #f3f8ff;
  color: #0f2d4a;
  border-bottom: 1px solid rgba(15, 40, 70, 0.12) !important;
}

table.dataTable tbody tr:hover {
  background: rgba(50, 118, 177, 0.06) !important;
}

.dataTables_wrapper .dataTables_filter input,
.dataTables_wrapper .dataTables_length select {
  border: 1px solid rgba(15, 40, 70, 0.18);
  border-radius: 10px;
  padding: 6px 10px;
  outline: none;
}

.dataTables_wrapper .dataTables_paginate .paginate_button {
  border-radius: 10px !important;
}

/* Responsividade */
@media (max-width: 768px) {
  nav {
    flex-wrap: wrap;
  }
  nav .menu-item {
    flex: 1 1 auto;
    padding: 15px 20px;
  }

  .ped-link {
    max-width: 260px;
  }
}
</style>